/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MstCustomerUpdateBase } from './MstCustomerUpdateBase';
import {
    MstCustomerUpdateBaseFromJSON,
    MstCustomerUpdateBaseFromJSONTyped,
    MstCustomerUpdateBaseToJSON,
    MstCustomerUpdateBaseToJSONTyped,
} from './MstCustomerUpdateBase';

/**
 * 
 * @export
 * @interface MstCustomerUpdate
 */
export interface MstCustomerUpdate {
    /**
     * 
     * @type {Array<MstCustomerUpdateBase>}
     * @memberof MstCustomerUpdate
     */
    body: Array<MstCustomerUpdateBase>;
}

/**
 * Check if a given object implements the MstCustomerUpdate interface.
 */
export function instanceOfMstCustomerUpdate(value: object): value is MstCustomerUpdate {
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function MstCustomerUpdateFromJSON(json: any): MstCustomerUpdate {
    return MstCustomerUpdateFromJSONTyped(json, false);
}

export function MstCustomerUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCustomerUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'body': ((json['body'] as Array<any>).map(MstCustomerUpdateBaseFromJSON)),
    };
}

export function MstCustomerUpdateToJSON(json: any): MstCustomerUpdate {
    return MstCustomerUpdateToJSONTyped(json, false);
}

export function MstCustomerUpdateToJSONTyped(value?: MstCustomerUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': ((value['body'] as Array<any>).map(MstCustomerUpdateBaseToJSON)),
    };
}

